import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FormActions } from '../../../components/form/index.js';
import Table from '../../../components/Table.tsx';
import { useCategoriesContext } from '../../../contexts/categories/categories.tsx';

const CategoriesBody = () => {
    const { categories, deleteCategory } = useCategoriesContext();
    const navigate = useNavigate();
    const columns = [
        {
            header: "name",
            name: "name",
            enableSorting: true,
            cell: (props: any) => {
                const { categoryID, name } = props.row;
                return (
                    <Link className="nav-link" to={`/admin/categories/${categoryID}`}>
                        <span >{name}</span>
                    </Link>
                );
            }
        },
        {
            header: "",
            name: "delete",
            actionHandler: (props: any) => {
                const { categoryID } = props.row;
                return deleteCategory(categoryID);
            },
            enableSorting: false
        }
    ]

    return (
        <>
            <Table columns={columns} rows={categories} />
            <FormActions
                mainAction={() => { navigate("/admin/categories/create"); }}
                mainActionText="Create"
            />
        </>
    );
};

export default CategoriesBody;